import { Unit_instance3vdlo4e4f5ggx as Unit_instance } from '../../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { constructCallableReference23y65rf941mch as constructCallableReference } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/reflectRuntime.mjs';
import { Phases_getInstance27czzec4fvnke as Phases_getInstance } from '../../request/HttpRequestPipeline.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { isSuspendFunction153vlp5l2npj9 as isSuspendFunction } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/typeCheckUtils.mjs';
import {
  initMetadataForObject1cxne3s9w65el as initMetadataForObject,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { Plugin_getInstance305tjh8i5k0u9 as Plugin_getInstance } from '../HttpSend.mjs';
import { plugin3vxt624hnu3pv as plugin } from '../HttpClientPlugin.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function SetupRequest$install$slambda($handler) {
  return constructCallableReference(function *($this$intercept, it, $completion) {
    yield* $handler($this$intercept.x4s_1, $completion);
    return Unit_instance;
  }, 2);
}
var SetupRequestClass;
function SetupRequest() {
  if (SetupRequestClass === VOID) {
    class $ {
      s5s(client, handler) {
        var tmp = Phases_getInstance().h5m_1;
        client.f5g_1.b4t(tmp, SetupRequest$install$slambda(handler));
      }
      m5m(client, handler) {
        return this.s5s(client, (!(handler == null) ? isSuspendFunction(handler, 1) : false) ? handler : THROW_CCE());
      }
    }
    initMetadataForObject($, 'SetupRequest');
    SetupRequestClass = $;
  }
  return SetupRequestClass;
}
var SetupRequest_instance;
function SetupRequest_getInstance() {
  return SetupRequest_instance;
}
var SenderClass;
function Sender() {
  if (SenderClass === VOID) {
    class $ {
      constructor(httpSendSender, coroutineContext) {
        this.y5o_1 = httpSendSender;
        this.z5o_1 = coroutineContext;
      }
      bw() {
        return this.z5o_1;
      }
      *a5p(requestBuilder, $completion) {
        return yield* this.y5o_1.y5q(requestBuilder, $completion);
      }
    }
    initMetadataForClass($, 'Sender', VOID, VOID, VOID, [1]);
    SenderClass = $;
  }
  return SenderClass;
}
function Send$install$slambda($handler, $client) {
  return constructCallableReference(function *($this$intercept, request, $completion) {
    return yield* $handler(new (Sender())($this$intercept, $client.e5g_1), request, $completion);
  }, 2);
}
var SendClass;
function Send() {
  if (SendClass === VOID) {
    class $ {
      t5s(client, handler) {
        var tmp = plugin(client, Plugin_getInstance());
        tmp.o5r(Send$install$slambda(handler, client));
      }
      m5m(client, handler) {
        return this.t5s(client, (!(handler == null) ? isSuspendFunction(handler, 2) : false) ? handler : THROW_CCE());
      }
    }
    initMetadataForObject($, 'Send');
    SendClass = $;
  }
  return SendClass;
}
var Send_instance;
function Send_getInstance() {
  return Send_instance;
}
//region block: init
SetupRequest_instance = new (SetupRequest())();
Send_instance = new (Send())();
//endregion
//region block: exports
export {
  Send_instance as Send_instance3jwyi367vhqvc,
  SetupRequest_instance as SetupRequest_instancezsckteg7b0pk,
};
//endregion

//# sourceMappingURL=CommonHooks.mjs.map
